import React from 'react';

import { Box } from '@chakra-ui/react';
import { AddPerson, Delete } from '@mesh.ai/rabbit';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { IconSteps, StepCard } from '../commonComponents';

const GuideSection = () => (
  <StepCard title="On Mesh you'll get notified of the following">
    <Box>
      <IconSteps
        steps={[
          {
            iconSvg: AddPerson,
            stepComp: <TextBodyMedium>Automatically onboard new employees of the company.</TextBodyMedium>,
          },
          {
            iconSvg: Delete,
            stepComp: <TextBodyMedium>Automatically remove the employees once the employee quits.</TextBodyMedium>,
          },
        ]}
      />
    </Box>
  </StepCard>
);

export { GuideSection };
